import { BasicsClass } from '@/common/BasicsClass';

export class SoundEffectPackAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getList', {
            url: '/admin/voice/soundList',
            name: 'list',
            label: '角色语音音效列表'
        }],
        ['add', {
            url: '/admin/voice/soundAdd',
            name: 'add',
            label: '添加角色语音音效'
        }],
        ['edit', {
            url: '/admin/voice/soundEdit',
            name: 'edit',
            label: '编辑角色语音音效'
        }],
        ['publish', {
            url: '/admin/voice/soundPublish',
            name: 'publish',
            label: '发布角色语音音效'
        }],
        ['delete', {
            url: '/admin/voice/soundDel',
            name: 'delete',
            label: '删除角色语音音效'
        }],
        ['infoList', {
            url: '/admin/voice/soundInfoList',
            name: 'infoList',
            label: '角色语音音效详情列表'
        }],
    ])



    public getList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    public add(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('add').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public edit(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('edit').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public publish(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('publish').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public delete(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('delete').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }


    public getInfoList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('infoList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }


}